import {Field} from 'formik';

import {
    FormikNumberInput,
    FormikTextarea,
    FormikTextInput,
    PlatformFieldset
} from '@flexinet/ui-components';
import {Stack} from '@mantine/core';


export const FormComponent = () => {

    return (
        <Stack gap={'xl'}>
            <PlatformFieldset legend={'Step Details'}>
                {/* phaseId and playbookId are seeded from the route params and are
                    not user-editable. They are kept as hidden Formik fields so
                    they flow through to the mutation payload. */}
                <Field name='phaseId' type='hidden' component='input'/>
                <Field name='playbookId' type='hidden' component='input'/>

                <Field
                    name='name'
                    label='Name'
                    description='Machine-readable identifier (e.g. "validate-domain-prereqs")'
                    component={FormikTextInput}
                    withAsterisk
                    my={'xl'}
                />

                <Field
                    name='displayName'
                    label='Display Name'
                    description='Human-friendly name shown in the UI'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='description'
                    label='Description'
                    description='What this step does'
                    component={FormikTextarea}
                    my={'xl'}
                />

                <Field
                    name='position'
                    label='Position'
                    description='Order of this step within the phase (zero-based, ascending)'
                    component={FormikNumberInput}
                    withAsterisk
                    my={'xl'}
                />
            </PlatformFieldset>

            <PlatformFieldset legend={'Execution Binding'}>
                <Field
                    name='taskStateName'
                    label='Task State Name'
                    description='Step Functions task-state identifier (e.g. "ValidateDomainPrereqs")'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='targetService'
                    label='Target Service'
                    description='Downstream AppSync API name (e.g. "flexi-domains-api")'
                    component={FormikTextInput}
                    my={'xl'}
                />

                <Field
                    name='targetOperation'
                    label='Target Operation'
                    description='GraphQL query/mutation field name (e.g. "validateApplicationDomainPrerequisites")'
                    component={FormikTextInput}
                    my={'xl'}
                />
            </PlatformFieldset>
        </Stack>
    );
};
